import React, { useState, useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import useLocalStorageState from 'hooks/useLocalStorageState'
import { request } from 'hooks/useApi'
import { useIntl } from 'react-intl'
import { useBrand } from 'contexts/BrandContext'

export const CurrentUserContext = React.createContext({})

export const useCurrentUser = () => React.useContext(CurrentUserContext)

const initalCurrentUser = {
  roles: [],
}

export const CurrentUserContextProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(initalCurrentUser)
  const [jwt, setJwt] = useLocalStorageState(null, 'voice.portal.jwt')
  const { locale } = useIntl()
  const brand = useBrand()

  const onLogIn = () => {
    const apiBase =
      brand.loginBase ||
      (typeof window !== 'undefined'
        ? window.env.RAZZLE_API_BASE
        : 'https://system.voicearchive.com')
    const origin =
      typeof window !== 'undefined'
        ? window.location.origin
        : 'http://voicearchive.com/en/voicefinder'
    const redirect = [
      encodeURI(`${origin}/${locale}/voicefinder/auth/callback?redirect=`),
      encodeURIComponent(
        encodeURI(
          (location.pathname.replace(/\/[a-z]{2}(-[a-z]{2})?\/voicefinder/gi, '') || '/') + location.search
        )
      ),
    ].join('')

    window.location = `${apiBase}/user/preauthenticate?redirect=${redirect}`
  }

  const onLogOut = () => {
    setJwt(null)
    setCurrentUser(initalCurrentUser)
  }

  useEffect(() => {
    request('/rest/v2/user/me')
      .then(({ data }) =>
        setCurrentUser({
          ...data,
          image: data
            ? data.image ||
              'https://voicearchive-branding.s3.eu-central-1.amazonaws.com/avatar-fallback.jpg'
            : null,
        })
      )
      .catch((err) => console.error(err))
  }, [jwt])

  if (typeof window !== 'undefined') {
    window.currentUser = currentUser
    window.jwt = jwt
  }

  return (
    <CurrentUserContext.Provider
      value={{ ...currentUser, onLogOut, onLogIn, setJwt }}
    >
      {children}
    </CurrentUserContext.Provider>
  )
}

export const AuthCallback = () => {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const { jwt, setJwt } = useCurrentUser()

  useEffect(() => {
    if (params.has('jwt')) {
      setJwt(params.get('jwt'))
    }

    if (params.has('redirect')) {
      navigate(params.get('redirect'))
    }
  }, [])

  return null
}

export default useCurrentUser
